import { forwardRef } from 'react';
import clsx from 'clsx';
import makeStyles from '@mui/styles/makeStyles';
import { IconButton as ButtonControl, CircularProgress } from '@mui/material';
import type { Theme } from '@mui/material/styles';
import type { IconButtonProps } from '@mui/material/IconButton';
import { Blocker } from '../blocker';

const useStyles = makeStyles<Theme>(() => ({
  root: {
    display: 'inline-flex',
    position: 'relative',
  },
  progress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  block: {
    height: '100%',
    left: '0',
    position: 'fixed',
    top: '0',
    width: '100%',
    zIndex: 10000,
  },
}));

interface Props extends IconButtonProps {
  loading?: boolean;
  to?: string;
}

export const IconButton = forwardRef<null, Props>(function IconButton({ loading, className, disabled, ...props }, ref) {
  const classes = useStyles();
  return (
    <div className={clsx(classes.root, className)}>
      <ButtonControl {...props} disabled={disabled || loading} ref={disabled || loading ? null : ref} />
      {loading ? <CircularProgress className={classes.progress} size={24} /> : null}
      {loading ? <Blocker /> : null}
    </div>
  );
});
